unit NetInstrumentListType;

interface

uses
  NetInstrumentType;

type
  TNetInstrumentListType = array of TNetInstrumentType;

implementation

end.
